import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';

import * as emailTemplateActions from '../actions/email-template.actions';
import { EmailTemplateHttpService } from '../services/email-template-http.service';
import { EmailTemplateModel } from '../models/email-template-model';

@Injectable()
export class EmailTemplateEffects {

  
  load$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<emailTemplateActions.Load>(emailTemplateActions.LOAD),
    switchMap(() => {
      return this.emailTemplateHttp.getAllEmailTemplates().pipe(
        map((emailTemplates: EmailTemplateModel[]) => new emailTemplateActions.LoadComplete(emailTemplates)));
    })
  ));

  constructor(
    private readonly actions$: Actions,
    private readonly emailTemplateHttp: EmailTemplateHttpService) {
  }

}
